import { safeSessionStorage } from './ssr-helper';
import { SESSION_STORAGE_KEYS } from '../constants';

const KEY = SESSION_STORAGE_KEYS.APPLICATION_STATE;

export function saveApplicationState(applicationState) {
  if (!applicationState || typeof applicationState !== 'object') return;
  try {
    const { templateData, ...rest } = applicationState;
    safeSessionStorage.setItem(KEY, JSON.stringify(rest));
  } catch (error) {
    console.warn('[applicationStateStorage] Error saving:', error);
  }
}

export function loadApplicationState() {
  try {
    const stored = safeSessionStorage.getItem(KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.warn('[applicationStateStorage] Error loading:', error);
    return null;
  }
}
